import React, { useEffect, useState, } from "react";

// Router
import { useLocation, useNavigate, useParams, Outlet } from "react-router-dom";

// Components
import { Layout } from "antd";
import useShowInsights from "../hooks/useShowInsights";
import InsightsServices from "../services/Insights.services";
import { isViewer } from "../utils/MainHelper";
import { useSelector } from "react-redux";

import ErrorPage from "../customcomponents/ErrorPage/ErrorPage";
import ReportBuilder from "./ReportBuilder/ReportBuilderLayout/ReportBuilder";
import InputPasswordModal from "./DashboardReport/DashboardReport"

const OneIntelligence = () => {
    const params = useParams();
    const navigate = useNavigate()
    const { password: passwordValue } = useSelector((state) => state.dashboardReport);
    const [showPasswordfield, setShowPasswordfield] = useState(isViewer());
    const [invalidPath, setInvalidPath] = useState(false)
    const [isInitial, setIsInitial] = useState(false)

    const { hasInsightPermission } = useShowInsights()

    useEffect(() => {
        if (hasInsightPermission) {
            InsightsServices.loadLanguages();
        }
    }, [hasInsightPermission]);

    useEffect(() => {
        if (isViewer() && !passwordValue) {
            setShowPasswordfield(true);
            let path = window?.sq?.oneintel?.hash;
            if (!path) {
                const { hash } = new URL(window.location.href)
                const tempHash = hash.substring(1);
                if (tempHash) {
                    path = tempHash
                }
            }
            if (path && path.split("/").length === 6) {
                navigate(path);
            }
        }
    }, [params, passwordValue]);


    const renderContent = () => {
        if (!isViewer()) return <Outlet />
        if (isInitial) return
        if (invalidPath && !isInitial) return <ErrorPage type="404" hideDefaultExtra />
        return <>
            {passwordValue && <ReportBuilder />}
            {showPasswordfield && <InputPasswordModal visible={showPasswordfield} onClose={setShowPasswordfield} />}
        </>
    }
    return (
        <Layout className="oneintel-main">
            <Layout.Content className="oneintel-content">
                {renderContent()}
            </Layout.Content>
        </Layout>
    );
};

export default OneIntelligence;
